import { useState, useEffect, useRef } from 'react'

export function useWebcamState() {
  const [isWebcamActive, setIsWebcamActive] = useState(false)
  const isWebcamActiveRef = useRef(isWebcamActive)

  useEffect(() => {
    isWebcamActiveRef.current = isWebcamActive
  }, [isWebcamActive])

  return { isWebcamActive, setIsWebcamActive, isWebcamActiveRef }
}
